import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import PhoneIcon from "@material-ui/icons/PhoneInTalkOutlined";
import CloseIcon from "@material-ui/icons/Close";

import AssignNumberDialog from "./AssignNumberDialog";

// Banner (CTA) no topo do editor — só aparece quando o agente ainda NÃO tem um
// número de entrada. Ao configurar, o AssignNumberDialog faz o deploy + vínculo.
const useStyles = makeStyles(theme => ({
  banner: {
    display: "flex", alignItems: "center", gap: 14, background: "#EFF8D6",
    border: "1px solid #C7E579", borderRadius: 14, padding: "12px 14px 12px 16px", marginBottom: 18,
  },
  icon: { width: 38, height: 38, borderRadius: 999, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, "& svg": { fontSize: 20, color: "#5f7a12" } },
  text: { flex: 1, minWidth: 0, fontSize: 13.5, color: "#3c4a12", lineHeight: 1.45, fontWeight: 500 },
  cta: { flexShrink: 0, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#fff", background: theme.app.dark, borderRadius: 8, padding: "8px 18px", boxShadow: "none", "&:hover": { background: theme.app.ink, boxShadow: "none" } },
  dismiss: { flexShrink: 0, color: "#7c8a52", padding: 4 },
}));

const AgentNumberBanner = ({ agentId, agentName, projectId, onDone }) => {
  const classes = useStyles();
  const [dismissed, setDismissed] = useState(false);
  const [open, setOpen] = useState(false);

  if (dismissed) return null;

  return (
    <>
      <div className={classes.banner}>
        <div className={classes.icon}><PhoneIcon /></div>
        <div className={classes.text}>Configure um número de telefone para o seu agente receber chamadas.</div>
        <Button className={classes.cta} onClick={() => setOpen(true)}>Configurar</Button>
        <IconButton size="small" className={classes.dismiss} onClick={() => setDismissed(true)} title="Dispensar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <AssignNumberDialog
        open={open}
        onClose={() => setOpen(false)}
        agentId={agentId}
        agentName={agentName}
        projectId={projectId}
        onDone={onDone}
      />
    </>
  );
};

export default AgentNumberBanner;
